'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeIcon = function (_React$Component) {
    _inherits(HomeIcon, _React$Component);

    function HomeIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, HomeIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeIcon.__proto__ || Object.getPrototypeOf(HomeIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { id: 'home-pin', xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24.002' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', wiwidth: width, height: height, transform: 'translate(0 0.002)', fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_123', transform: 'translate(-144 -1487.998)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Bold_123' },
                        _react2.default.createElement('path', { id: 'Shape_364', fill: primary, d: 'M156.5,1504a6.5,6.5,0,0,1,10.972-4.71.31.31,0,0,0,.275.08c.3-.07.326-.51.1-.73l-10.816-10.23a1.491,1.491,0,0,0-2.059,0l-10.815,10.23a.5.5,0,0,0,.343.86h2a.5.5,0,0,1,.5.5v10a1,1,0,0,0,1,1h10.833a.5.5,0,0,0,.447-.28.492.492,0,0,0-.047-.52C157.886,1508.42,156.5,1506.08,156.5,1504Z' }),
                        _react2.default.createElement('path', { id: 'Shape_365', fill: primary, d: 'M158,1504a5,5,0,0,1,10,0c0,3.17-4.457,7.66-4.646,7.85a.491.491,0,0,1-.707,0C162.457,1511.66,158,1507.17,158,1504Zm3.25,0a1.748,1.748,0,0,0,1.75,1.75h0a1.75,1.75,0,1,0-1.75-1.75Z', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HomeIcon, [{
        key: 'render',
        value: function render() {
            var size = 24;
            if (this.props.size) size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                this.getIcon(size, size, this.props.primary)
            );
        }
    }]);

    return HomeIcon;
}(_react2.default.Component);

exports.default = HomeIcon;